// extracted by mini-css-extract-plugin
export default {"page_heading":"PageHeading_page_heading__k-4Hu"};